import { copy } from "plos/src/styles/copy.css";
import { Trans } from "react-i18next";

const StatisticsHelp = () => {
  return (
    <div className={copy}>
      <Trans ns="help" i18nKey="contextualHelp.statistics.description">
        <p>
          You can use the Statistics page to identify players in good form or to
          find high-value players delivering strong points for their price.
        </p>
        <p>
          Tables can be sorted by metrics such as Total Points, Form, Goals,
          Assists and Bonus Points to compare players across different
          categories.
        </p>
        <p>
          Advanced metrics such as Expected Goals (xG) and Expected Assists (xA)
          help measure the quality of chances a player is involved in and can
          highlight players who may perform well in future matches.
        </p>
        <p>
          Transfer activity can also provide insight into which players are
          currently popular among Fantasy managers.
        </p>
      </Trans>
    </div>
  );
};

export default StatisticsHelp;
